import React, { Suspense } from "react";
import { Box, LinearProgress } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useTheme } from "@emotion/react";
import Header from "./components/header";

const Dashboard = () => {
  const theme = useTheme();

  return (
    <Box component="div" sx={style.container}>
      <Header />
      <Box
        component="div"
        sx={{
          ...style.child,
          [theme.breakpoints.up("lg")]: {
            paddingX: 4,
          },
          [theme.breakpoints.down("xs")]: {
            paddingTop: 6,
          },
        }}
      >
        <Suspense fallback={<LinearProgress />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default React.memo(Dashboard);

const style = {
  container: {
    minHeight: "100vh",
    display: "flex",
    "@media all and (-ms-high-contrast:none)": {
      height: 0, // IE11 fix
    },
  },
  child: {
    paddingTop: 8,
    flexGrow: 1,
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
  },
};
